import { render, staticRenderFns } from "./PendingRequestsDialog.vue?vue&type=template&id=5be95cf4"
import script from "./PendingRequestsDialog.vue?vue&type=script&lang=js"
export * from "./PendingRequestsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports